import React from 'react';

import { useHiveBranch } from '@gitbook/hive-react';

import { hasPageId, RealtimeParticipants, useContentNavigation } from '../../../Components';

/**
 * Realtime participants in the space.
 */
export function SpaceRealtimeParticipants() {
    const hiveBranch = useHiveBranch();
    const { navigateToPage } = useContentNavigation();

    return hiveBranch ? (
        <React.Suspense fallback={null}>
            <RealtimeParticipants
                branch={hiveBranch}
                className="max-lg:hidden"
                onAvatarPress={(participant) => {
                    if (hasPageId(participant) && participant.pageId) {
                        navigateToPage(hiveBranch.revision, participant.pageId);
                    }
                }}
            />
        </React.Suspense>
    ) : null;
}
